import { Lightning, Colors, Utils } from '@lightningjs/sdk';

export default class VisibleButton extends Lightning.Component {
  static _template() {
    return {
      VisibleButton: {
        collision: true,
        y: 385,
        x: 625,
        // w: 100,
        // h: 100,
        texture: Lightning.Tools.getSvgTexture(Utils.asset('images/show.svg'), 67, 67),
        // rect: true,
      },
    };
  }

  get _Button() {
    return this.tag('VisibleButton');
  }

  _changeIcon(passwordMode) {
    if (passwordMode) {
      this._Button.patch({
        texture: Lightning.Tools.getSvgTexture(Utils.asset('images/hide.svg'), 67, 67),
      });
    } else {
      this._Button.patch({
        texture: Lightning.Tools.getSvgTexture(Utils.asset('images/show.svg'), 67, 67),
      });
    }
  }

  _focus() {
    this._Button.patch({
      color: Colors('#02AC25').get(),
    });
  }

  _unfocus() {
    this._Button.patch({
      color: Colors('#d6d6d6').get(),
    });
  }

  _handleHover() {
    this.fireAncestors('$setState', 'VisibleButton');
    this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }
}
